import React from 'react'
import s from './teacher-profile-card.module.scss'
import { getFullName } from '@utils/lib/getFullname';
import { TextWithEmoji } from '@shared/ui/text-with-emoji/text-with-emoji';

export const TeacherProfileCard = ({teacher}) => {

	const avatarSrc = teacher?.avatar
		? process.env.REACT_APP_STORAGE_URL + teacher?.avatar?.image
		: process.env.REACT_APP_STORAGE_URL + 'images/default_avatar.png'

	return (
		<div className={s.profileWrapper}>
			<img
				className={s.avatar}
				src={avatarSrc}
				alt={getFullName(teacher)}
				onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = process.env.REACT_APP_STORAGE_URL + 'images/default_avatar.png' }}
			/>
			<div className={s.contentWrapper}>
					<h1 className={s.name}>
						{getFullName(teacher)}
					</h1>
					<div className={s.instrumentsWrapper}>
						{teacher?.instruments?.map((i) => (
							<div key={i.id} className={s.instrumentTag}><TextWithEmoji text={i.name}/></div>
						))}
					</div>
			</div>
		</div>
	)
}
